import { useEffect, useState } from "react";
import { Table, Button, Modal, message, Card, Input, Pagination, Alert } from 'antd';
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import CategoryCareerForm from './categoryCareerForm';

const CategoryCareer = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [categoryCareer, setCategoryCareer] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [total, setTotal] = useState(0);
    const [successMsg, setSuccessMsg] = useState(null);

    const fetchCategoryCareer = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/api/category_jobs?page=${pageNumber}&limit=${limit}&search=${searchText}`);
            console.log('FetchCategoryCategory response:', res);
            setCategoryCareer(res.data.data|| []);
            setTotal(res.data.data.count || 0);
        } catch (error) {
            console.error('FetchCategoryCareer error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategoryCareer(page);

    }, [page, searchText]);

    const handleSubmit = async (formData) => {
        try {
            if (editData) {
                await axios.put(`${BASE_URL}/api/category_jobs/${editData.id}`, formData);
                setSuccessMsg('Category Career updated');
                setTimeout(() => setSuccessMsg(null), 3000);
            } else {
                await axios.post(`${BASE_URL}/api/category_jobs`, formData);
                setSuccessMsg('Category Career Added');
                setTimeout(() => setSuccessMsg(null), 3000);
            }
            setOpen(false);
            setEditData(null);
            fetchCategoryCareer(1);
        } catch (err) {
            message.error('Failed to submit Category Career');
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${BASE_URL}/api/category_jobs/${id}`);
            setSuccessMsg('Category Career deleted');
            setTimeout(() => setSuccessMsg(null), 3000);

            fetchCategoryCareer(page);
        } catch (err) {
            message.error('Failed to delete Category Career');
        }
    };

    const columns = [
        {
            title: "No",
            render: (_, __, index) => (page - 1) * limit + index + 1,
        },
        { title: 'Name', dataIndex: 'name' },
        {
            title: 'Actions',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Button
                        style={{
                            backgroundColor: '#ec4899',
                            borderColor: '#ec4899',
                            color: '#fff',
                            marginRight: 8,
                        }}
                        icon={<EditOutlined />}
                        type="link"
                        onClick={() => {
                            setEditData({
                                ...record,
                            });
                            setOpen(true);
                        }} />
                    <Button
                        style={{
                            backgroundColor: '#374151',
                            borderColor: '#374151',
                            color: '#fff',
                            marginRight: 8,
                        }}
                        icon={<DeleteOutlined />}
                        type="link"
                        onClick={() => {
                            Modal.confirm({
                                title: 'Are you sure you want to delete this Category Career?',
                                centered: true,
                                okText: 'Yes',
                                okType: 'danger',
                                cancelText: 'No',
                                onOk: () => handleDelete(record.id),
                            });
                        }} />
                </div>
            ),
        },
    ];

    return (
        <Card title='Category Jobs'>
            {successMsg && (
                <Alert
                    message={successMsg}
                    type="success"
                    showIcon
                    style={{
                        marginBottom: 16,
                        borderRadius: 8,
                        backgroundColor: '#f6ffed',
                        color: '#389e0d',
                    }}
                />
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Input.Search
                    placeholder="Search Category Jobs.."
                    allowClear
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: 300 }}
                />
                <Button
                    style={{
                        backgroundColor: '#ec4899',
                        borderColor: '#ec4899',
                        color: '#fff',
                    }}
                    onClick={() => {
                        setEditData(null);
                        setOpen(true);
                    }}
                >
                    + Add Category Career
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={categoryCareer}
                rowKey="id"
                loading={loading}
                pagination={false}
                style={{ marginTop: 20 }}
            />

            <Pagination
                current={page}
                pageSize={limit}
                total={total}
                onChange={(page) => setPage(page)}
                style={{ marginTop: 16, textAlign: 'right' }}
            />

            <Modal
                open={open}
                onCancel={() => {
                    setOpen(false);
                    setEditData(null);
                }}
                footer={null}
                destroyOnClose
            >
                <CategoryCareerForm
                    initialValues={editData}
                    onSuccess={handleSubmit}
                    editMode={!!editData}
                />
            </Modal>
        </Card>
    );
};

export default CategoryCareer;